import { render, staticRenderFns } from "./MemberCenterAd.vue?vue&type=template&id=ae8daaa8&scoped=true&"
import script from "./MemberCenterAd.vue?vue&type=script&lang=js&"
export * from "./MemberCenterAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8daaa8",
  null
  
)

export default component.exports